<ng-container *ngIf="sections">
    <h4>Amenities</h4>

    <div class="margin-top-2 spacer"></div>

    <div class="margin-top-2 amenities-container" *ngFor="let section of sections; index as i">
        <mat-expansion-panel [expanded]="i == 0">
            <mat-expansion-panel-header [collapsedHeight]="'40px'">
                <h5>{{section.name | titlecase}}</h5>
            </mat-expansion-panel-header>

            <div fxLayout="row wrap">
                <p class=margin-top-1
                   fxLayoutAlign="start center"
                   fxFlex.lt-sm="0 1 calc(50% - 10px)"
                   fxFlex.gt-xs="0 1 calc(33.3% - 20px)"
                   *ngFor="let amenity of section.amenities"
                   [class.display-none-important]="!isVisible(amenity.amenityId)">
                    <mat-icon>check</mat-icon>

                    <span class="size-1"></span>

                    <span class="text-medium">{{amenity.name | titlecase}}</span>

                    <span class="size-3"></span>
                </p>
            </div>
        </mat-expansion-panel>
    </div>
</ng-container>
